import {
  LessonPlanProperties,
  MultigradeLessonPlanProperties,
} from 'apps/web/enums/pageKey';

import FORM_KEYS from './formKeys';

/* this is used for mapping the form values to the formContents object
 the key field is the key in the formContents, and the value field is the key in the default values
 do note than when making your forms, the values in the formContents should be the same as the keys in the default values */

const FORM_CONTENT_MAPPER_KEYS = {
  LocalLp: [
    {
      key: LessonPlanProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: LessonPlanProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: LessonPlanProperties.language,
      value: FORM_KEYS.language,
    },
    {
      key: LessonPlanProperties.lessonFormat,
      value: FORM_KEYS.lessonFormat,
    },
    {
      key: LessonPlanProperties.objective,
      value: FORM_KEYS.objective,
    },
    {
      key: LessonPlanProperties.objective2,
      value: FORM_KEYS.objective2,
    },
    {
      key: LessonPlanProperties.objective3,
      value: FORM_KEYS.objective3,
    },
    {
      key: LessonPlanProperties.objective4,
      value: FORM_KEYS.objective4,
    },
  ],
  DefaultLP: [
    {
      key: LessonPlanProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: LessonPlanProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: LessonPlanProperties.time,
      value: FORM_KEYS.time,
    },
    {
      key: LessonPlanProperties.modality,
      value: FORM_KEYS.modality,
    },
    {
      key: LessonPlanProperties.lessonFormat,
      value: FORM_KEYS.lessonFormat,
    },
    {
      key: LessonPlanProperties.objective,
      value: FORM_KEYS.objective,
    },
    {
      key: LessonPlanProperties.objective2,
      value: FORM_KEYS.objective2,
    },
    {
      key: LessonPlanProperties.objective3,
      value: FORM_KEYS.objective3,
    },
    {
      key: LessonPlanProperties.language,
      value: FORM_KEYS.language,
    },
  ],
  AmericanLP: [
    {
      key: LessonPlanProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: LessonPlanProperties.curriculumFramework,
      value: FORM_KEYS.curriculumFramework,
    },
    {
      key: LessonPlanProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: LessonPlanProperties.specificStandards,
      value: FORM_KEYS.specificStandards,
    },
    {
      key: LessonPlanProperties.strategies,
      value: FORM_KEYS.strategies,
    },
    {
      key: LessonPlanProperties.time,
      value: FORM_KEYS.time,
    },
    {
      key: LessonPlanProperties.lessonFormat,
      value: FORM_KEYS.lessonFormat,
    },
    {
      key: LessonPlanProperties.objective,
      value: FORM_KEYS.objective,
    },
    {
      key: LessonPlanProperties.objective2,
      value: FORM_KEYS.objective2,
    },
    {
      key: LessonPlanProperties.objective3,
      value: FORM_KEYS.objective3,
    },
    {
      key: LessonPlanProperties.language,
      value: FORM_KEYS.language,
    },
  ],
  MontessoriLP: [
    {
      key: LessonPlanProperties.title,
      value: FORM_KEYS.title,
    },
    {
      key: LessonPlanProperties.classProgram,
      value: FORM_KEYS.classProgram,
    },
    {
      key: LessonPlanProperties.language,
      value: FORM_KEYS.language,
    },
    {
      key: LessonPlanProperties.lessonFormat,
      value: FORM_KEYS.lessonFormat,
    },
    {
      key: LessonPlanProperties.materials,
      value: FORM_KEYS.materials,
    },
    {
      key: LessonPlanProperties.prerequisites,
      value: FORM_KEYS.prerequisites,
    },
    {
      key: LessonPlanProperties.keyArea,
      value: FORM_KEYS.keyArea,
    },
    {
      key: LessonPlanProperties.keyArea2,
      value: FORM_KEYS.keyArea2,
    },
    {
      key: LessonPlanProperties.keyArea3,
      value: FORM_KEYS.keyArea3,
    },
    {
      key: LessonPlanProperties.objective,
      value: FORM_KEYS.objective,
    },
    {
      key: LessonPlanProperties.objective2,
      value: FORM_KEYS.objective2,
    },
    {
      key: LessonPlanProperties.objective3,
      value: FORM_KEYS.objective3,
    },
  ],
  MultigradeLP: [
    {
      key: MultigradeLessonPlanProperties.gradeLevel,
      value: FORM_KEYS.gradeLevel,
    },
    {
      key: MultigradeLessonPlanProperties.subject,
      value: FORM_KEYS.subject,
    },
    {
      key: MultigradeLessonPlanProperties.language,
      value: FORM_KEYS.language,
    },
    {
      key: MultigradeLessonPlanProperties.lessonFormat,
      value: FORM_KEYS.lessonFormat,
    },
    {
      key: MultigradeLessonPlanProperties.objective,
      value: FORM_KEYS.objective,
    },
    {
      key: MultigradeLessonPlanProperties.objective2,
      value: FORM_KEYS.objective2,
    },
    {
      key: MultigradeLessonPlanProperties.objective3,
      value: FORM_KEYS.objective3,
    },
  ],
};

export default FORM_CONTENT_MAPPER_KEYS;
